import { JointEntityShape } from '../Shape/JointEntityShape';
import { Composition } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/Composition';
import { MDAConstant } from '../../Base/MDAConstant';
import { AssoLink } from '../../BaseShape/AssoLink';
import { MDRepository } from '../../../MD/MDRepository';

export class JointCompositionLink extends AssoLink {
  constructor(opt?: any) {
    super(opt);
    this.set('type', 'mst.JointCompositionLink');
    this.attr({
      line: {
        stroke: 'orange', // 橙色
        targetMarker: { fill: 'none', d: 'M 10 -5 L 0 0 L 10 5 L 0 0 z' },
        sourceMarker: { fill: 'orange', d: 'M 20 0 L 10 5 L 0 0 L 10 -5 z' }
      }
    });
    // 反序列化调用，手工创建的时候不调用
    if (opt) {
      this.setMD(opt?.shape, opt?.model, true);
    }
  }

  changeTarget(source: joint.dia.Element, target: joint.dia.Element) {
    if (target instanceof JointEntityShape && source instanceof JointEntityShape) {
      const sourceEntity = source.entity;
      const targetEntity = target.entity;
      let relationship = this.element() as Composition;
      if (relationship === null) {
        relationship = MDRepository.createComposition(null, sourceEntity, targetEntity, false);
      }
      relationship.name = `${targetEntity.name}_composition_${sourceEntity.name}`;
      relationship.displayName = `${targetEntity.displayName}_组合成_${sourceEntity.displayName}`;
      relationship.description = relationship.displayName;
      relationship.targetEntity = targetEntity;
      // const relationship = MDRepository.createComposition(null, sourceEntity, targetEntity, false);
      this.setModel(relationship);
      sourceEntity.targetCompositions.push(relationship);
      targetEntity.sourceCompositions.push(relationship);
      return relationship;
    }
    return null;
  }

  get composition(): Composition {
    return this.element() as Composition;
  }

  public shapeType(): string {
    return MDAConstant.Link.ADD_COMPOSITION;
  }

  /**
   * 检查源和目标类型对当前关系是否有效
   * 组合关系：仅用于实体与实体
   * @param sourceType 源类型
   * @param targetType 目标类型
   * @returns 有效返回true
   */
  public checkShapeType(sourceType: string, targetType: string): boolean {
    if (sourceType === MDAConstant.Type.ADD_ENTITY && targetType === MDAConstant.Type.ADD_ENTITY) {
      return true;
    }
    return false;
  }
}
